import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { useDispatch, useSelector } from "react-redux";
import { putDevolvolverTransportadora } from "../../state/order/actions";
import { types } from "../../state/order/types";

import InputMask from "react-input-mask";
import Authorization from "./Authorization";

import { StorageUser } from "../../main/StorageUser";

const useStyles = makeStyles(() => ({
  contentTitle: {
    color: "#292929",
    fontSize: "14px",
    marginTop: 0,
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid #EEE",
    border: "none",
  },
  textField: {
    marginTop: 15,
  },
  dateTimePicker: {
    marginTop: 15,
  },
  dialogActions: {
    justifyContent: "space-between",
    padding: "8px 24px 16px",
  },
}));

export default function DevolverTransportadoraModal(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, handleClose, codigoExterno, origem, setRefreshes } = props;
  const { setModalClosed } = useSelector((state) => state.orders);

  const [openModal, setOpenModal] = useState(open);
  const [data, setData] = useState({
    nomeTransportadora: "",
    nomeColetor: "",
    cpfColetor: "",
  });

  const storageUser = new StorageUser();

  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );

  const disabled =
    data.nomeTransportadora.length === 0 ||
    data.nomeColetor.length === 0 ||
    data.cpfColetor.length < 14;

  const handleInput = (e) => {
    const { name, value } = e.target;

    setData((data) => ({
      ...data,
      [name]: name === "cpfColetor" ? value.trim() : value,
    }));
  };

  const handleSubmit = async ({ nomeAutorizador, emailAutorizador } = {}) => {
    await dispatch(
      putDevolvolverTransportadora(
        origem,
        codigoExterno && codigoExterno.replace("#", "%23"),
        { ...data, nomeAutorizador, emailAutorizador }
      )
    );
    setRefreshes((refreshes) => refreshes + 1);
  };

  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  useEffect(() => {
    if (setModalClosed) {
      setOpenModal(false);

      dispatch({
        type: types.SET_MODAL_CLOSED,
        payload: false,
      });
    }
  }, [setModalClosed, dispatch]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        className={classes.dialog}
        open={openModal}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <p className={classes.contentTitle}>Preencha todos os campos</p>

          <hr className={classes.hr} />

          <TextField
            variant="outlined"
            fullWidth
            label="Nome da transportadora*"
            name="nomeTransportadora"
            className={classes.textField}
            value={data.nomeTransportadora}
            onChange={handleInput}
          />

          <TextField
            variant="outlined"
            fullWidth
            label="Nome do coletor*"
            name="nomeColetor"
            className={classes.textField}
            value={data.nomeColetor}
            onChange={handleInput}
          />

          <InputMask
            mask="999.999.999-99"
            value={data.cpfColetor}
            onChange={handleInput}
            maskChar=" "
          >
            {() => (
              <TextField
                fullWidth
                variant="outlined"
                label="CPF do coletor*"
                name="cpfColetor"
                value={data.cpfColetor}
                className={classes.textField}
              />
            )}
          </InputMask>
        </DialogContent>

        {requireAutorizador && (
          <Authorization
            action={handleSubmit}
            disabled={disabled}
            cancel={handleClose}
            cancelText="Fechar"
            actionText="Devolver para transportadora"
          />
        )}

        {!requireAutorizador && (
          <>
            <hr className={classes.hr} />

            <DialogActions className={classes.dialogActions}>
              <Button onClick={handleClose} variant="outlined">
                Fechar
              </Button>
              <Button
                onClick={() => handleSubmit()}
                variant="contained"
                color="secondary"
                disabled={disabled}
              >
                Devolver para transportadora
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
}
